module.exports = {
  'Образовательная платформа': 'Educational platform',
  'Образовательная платформа АИС EDUS «Электронный колледж» автоматизирует процессы обучения учебных заведений ТиПО РК.': 'The EDUS AIS "Electronic College" educational platform automates learning processes for TVET institutions in the Republic of Kazakhstan.',
  'Следите за нами': 'Follow us',
  'Наши сервисы': 'Our services',
  'Электронный колледж': 'Electronic college',
  'Электронная школа': 'Electronic school',
  'Электронный детсад': 'Electronic kindergarten',
  'Дистанционное обучение': 'Distance learning',
  'Онлайн-тестирование': 'Online testing',
  'Приложения': 'Applications',
  'Вы можете установить мобильное приложения для абитуриентов': 'You can install the mobile application for applicants',
  'Политика': 'Policy',
  'Пользовательское соглашение': 'User agreement',
  'Выбор региона': 'Region selection',
  'Колледжи': 'Colleges',
  'Специальности': 'Specialties',
  'Информация': 'Information',
  'Вопрос-ответ': 'FAQ',
  'Главная': 'Home',
  'Мои заявки': 'My applications',
  'Виртуальный блог': 'Virtual blog',
  'Профиль': 'Profile',
  'Выход': 'Logout',
  'Абитуриент': 'Applicant',
  'Кабинет абитуриента': 'Applicant portal',
  'welcome': 'Welcome <span class="blue--text text--darken-3">!</span>',
  'вам доступны следующие разделы': 'the following sections are available to you',
  'Раздел предназначен для подачи документов, отслеживание их статуса и получения уведомления по заявкам.': 'This section is for submitting documents, tracking their status, and receiving notifications about applications.',
  'Перейти': 'Go to',
  'С помощью данного раздела можете задать вопросы напрямую в приемные комиссии образовательного учреждения.': 'Use this section to ask questions directly to the admissions offices of educational institutions.',
  'Ранжирование': 'Ranking',
  'Результаты конкурса по поданным заявкам будут отображены в этом разделе.': 'Competition results for submitted applications will be displayed in this section.',
  'Добавить': 'Add',
  'Посмотреть': 'View',
  'Отозвать заявку': 'Withdraw application',
  'Выберите ЭЦП': 'Select EDS',
  'Введите пароль': 'Enter password',
  'Подписать': 'Sign',
  'Задать вопрос': 'Ask a question',
  'Обязательное поле': 'Required field',
  'Отправить': 'Send',
  'Отправить запрос ': 'Send request',
  'Проверка запроса': 'Request verification',
  'Чтобы продолжить, нажмите на кнопку ниже. Мы отправим вам сообщение для подтверждения вашей личности.': 'To continue, click the button below. We will send you a message to verify your identity.',
  'Колледж': 'College',
  'После подтверждения вашей личности через телефон, нажмите на кнопку ниже для проверки данных.': 'After verifying your identity by phone, click the button below to check your data.',
  'К сожалению, произошла ошибка при подтверждении вашей личности. Пожалуйста, попробуйте еще раз. Если проблема сохраняется, свяжитесь с поддержкой.': 'Unfortunately, an error occurred while verifying your identity. Please try again. If the problem persists, contact support.',
  'Вопрос': 'Question',
  'статус не подтвержден. Пожалуйста, подтвердите свою личность, затем нажмите на кнопку "Проверка данных".': 'status is not confirmed. Please verify your identity, then click the "Data verification" button.',
  'Ваш статус подтвержден! Вы успешно подтвердили свою личность!': 'Your status is confirmed! You have successfully verified your identity!',
  'Ответ': 'Answer',
  'Тип заявки': 'Application type',
  'Профдиагностика': 'Career diagnostics',
  'Данные': 'Data',
  'Образование': 'Education',
  'Квота': 'Quota',
  'Специальность': 'Specialty',
  'Подготовка специалистов среднего звена и прикладного бакалавра': 'Training of mid-level specialists and applied bachelors',
  'Бесплатное, за счет средств государственного образовательного заказа': 'Free, funded by the state educational order',
  'Продолжить': 'Continue',
  'Подготовка квалифицированных рабочих кадров': 'Training of qualified workers',
  'Платное, за счет собственных средств': 'Paid, at own expense',
  'Пройдите профдиагностику на сайте': 'Complete career diagnostics on the website',
  'Назад': 'Back',
  'Далее': 'Next',
  'Данные абитуриента': 'Applicant data',
  'Данные заявителя': 'Declarant data',
  'Код': 'Code',
  'Неправильный формат ИИН': 'Invalid IIN format',
  'Контактные данные': 'Contact details',
  'Введите корректный E-mail': 'Enter a valid e-mail',
  'Неправильный формат телефона': 'Invalid phone format',
  'Данные о школе': 'School data',
  'Неправильный формат': 'Invalid format',
  'Год не может быть меньше 1901': 'Year cannot be less than 1901',
  'Год не может быть больше текущего': 'Year cannot be greater than the current year',
  'Дата не может быть позже текущей': 'Date cannot be later than today',
  'Размер файла не должен превышать 4 Мб': 'File size must not exceed 4 MB',
  '(МАКСИМАЛЬНЫЙ ОБЪЕМ ФАЙЛА НЕ ДОЛЖЕН ПРЕВЫШАТЬ 10 МБ)': '(MAXIMUM FILE SIZE MUST NOT EXCEED 10 MB)',
  'Специальность №': 'Specialty No.',
  'Данные колледжа': 'College data',
  'Профиль колледжа': 'College profile',
  'Новости': 'News',
  'Госзаказ': 'State order',
  'Заявки': 'Applications',
  'Новые заявки': 'New applications',
  'Все заявки': 'All applications',
  'Экзамены': 'Exams',
  'Все экзамены': 'All exams',
  'Статистика заявок': 'Application statistics',
  'Заполняемость мест': 'Seat occupancy',
  'Текущий рейтинг': 'Current ranking',
  'Итоги': 'Results',
  'Экспорт данных': 'Data export',
  'Госуслуга': 'Public service',
  'Прием документов': 'Document intake',
  'Платное обучение': 'Paid education',
  'Рабочие квалификации': 'Worker qualifications',
  'Среднее звено': 'Mid-level specialists',
  'Общежитие': 'Dormitory',
  'Питание': 'Meals',
  'Экспорт': 'Export',
  'Обратная связь': 'Feedback',
  'Новые запросы': 'New requests',
  'Все обращения': 'All inquiries',
  'Статистика': 'Statistics',
  'Тех. поддержка': 'Tech support',
  'Отправленные': 'Sent',
  'Написать всем': 'Message everyone',
  'Новости колледжа': 'College news',
  'Добавить новость': 'Add news',
  'Значение поле слишком короткое': 'Field value is too short',
  'Нет данных': 'No data',
  'Удалить': 'Delete',
  'Закрыть': 'Close',
  'Заявки абитуриентов': 'Applicant applications',
  'Тенденция поступления новых заявок': 'Trend of incoming applications',
  'Сегодня': 'Today',
  'Вчера': 'Yesterday',
  'Всего': 'Total',
  'Поданные заявки по дням': 'Applications submitted by day',
  'Платно': 'Paid',
  'Уведомить о поступлении заявки': 'Notify about incoming application',
  'Принять заявку': 'Accept application',
  'Отклонить заявку': 'Reject application',
  'Назначить экзамен': 'Schedule exam',
  'Список специальностей': 'Specialty list',
  'Добавить специальности': 'Add specialties',
  'Добавить новую специальность': 'Add new specialty',
  'Фильтры': 'Filters',
  'Форма оплаты': 'Payment type',
  'Тип подготовки': 'Training type',
  'Тип образования': 'Education type',
  'Форма обучения': 'Study form',
  'Подтвердите удаление': 'Confirm deletion',
  'Отмена': 'Cancel',
  'Редактировать': 'Edit',
  'Сохранить': 'Save',
  'Изменить картинку': 'Change image',
  'Заявки на общежитие': 'Dormitory applications',
  'Заявки на питание': 'Meal applications',
  'Новый': 'New',
  'Закрыт': 'Closed',
  'Закрыт с ответом': 'Closed with answer',
  'Ответить': 'Reply',
  'Выберите ЭЦП физического лица': 'Select individual EDS',
  'Выберите ЭЦП юридического лица': 'Select legal entity EDS',
  'sign_as_abiturient': 'Sign in to <span class="green--text text-darken-1">applicant</span> portal',
  'sign_as_college': 'Sign in to <span class="green--text text-darken-1">college</span> portal',
  'sign_as_department': 'Sign in to <span class="green--text text-darken-1">TVET</span> portal',
  'Войти в систему': 'Sign in',
  'Войти': 'Sign in',
  'abiturient_login_text': '<p>Access to the personal account is provided through an electronic digital signature (EDS) for citizens. If needed, you can <a href="https://www.youtube.com/watch?v=Ilipo-v6zBo" target="_blank">watch</a> or <a href="/portal/static/abiturient_instruction_ru.pdf" download>download</a> the system user guide.</p><p>The system allows you to submit documents for admission to college for free education under the state order and track their status. Final results are shown in the ranking section. You can also ask questions to the admissions office.</p>',
  'college_login_text': '<p>Access to the personal account is provided through an electronic digital signature (EDS) of a legal entity. If needed, you can <a href="#">watch</a> or <a href="/portal/static/comission_instruction_ru.pdf">download</a> the system user guide.</p><p>The main functionality includes reviewing and processing incoming applications, scheduling special exams, and admissions consultations.</p>',
  'department_login_text': '<p>Access to the personal account is provided through an electronic digital signature (EDS) of a legal entity. If needed, you can <a href="#">watch</a> or <a href="#">download</a> the system user guide.</p><p>The system provides application monitoring, up-to-date statistics, and the number of available state-order seats in subordinate organizations (colleges). A virtual blog is available.</p>',
  'Управление колледжом': 'College management',
  'sign_for': 'Sign in as an <span class="blue--text text--darken-3">organization</span>',
  'Вход в кабинет абитуриента': 'Applicant portal sign-in',
  'ИС позволяет подавать документы для поступления в колледж на бесплатное обучение по государственному заказу и отслеживать их статус. Итоговые результаты отображаются в разделе ранжирование. Есть возможность задать интересующие вопросы в приемную комиссию.': 'The system allows you to submit documents for admission to college for free education under the state order and track their status. Final results are shown in the ranking section. You can also ask questions to the admissions office.',
  'Вход в кабинет': 'Portal sign-in',
  'Приемная комиссия колледжа': 'College admissions office',
  'Приемная комиссия колледжа может отслеживать поступающие заявки от абитуриентов. Система позволяет управлять процессами приема и отказа в колледж. Требуется ЭЦП юридического учреждения.': 'The college admissions office can track incoming applications from applicants. The system allows managing admission and rejection processes. A legal entity EDS is required.',
  'Управление ТиПО': 'TVET management',
  'Вход в кабинет для Управления Образования (ТиПО) позволяет проводить мониторинг по приему абитуриентов подведомственных организаций (колледжей). Отображаются актуальные статистические данные. Имеется виртуальный блог.': 'The TVET management portal allows monitoring applicant admissions in subordinate organizations (colleges). Up-to-date statistics are displayed. A virtual blog is available.',
  'Просмотр заявки': 'View application',
  'Заявка успешно отозвана.': 'Application successfully withdrawn.',
  'Регион': 'Region',
  'Заголовок вопроса': 'Question title',
  'Ваш вопрос': 'Your question',
  'Я получил(а) и ознакомился(ась) с результатами профдиагностики': 'I have received and reviewed the career diagnostics results',
  'Тип заявителя': 'Declarant type',
  'Фамилия': 'Last name',
  'Имя': 'First name',
  'Отчество': 'Patronymic',
  'Дата рождения': 'Date of birth',
  'Статус гражданина': 'Citizenship status',
  'Национальность': 'Nationality',
  'ИИН': 'IIN',
  'Электронная почта': 'E-mail',
  'Номер телефона': 'Phone number',
  'Номер телефона родителя': 'Parent phone number',
  'Страна': 'Country',
  'Школа': 'School',
  'Год окончания': 'Graduation year',
  'Тип документа': 'Document type',
  'Документ об образовании': 'Education document',
  'Тип льготы': 'Benefit type',
  'Документ подтверждающий льготу': 'Benefit confirmation document',
  'Организация образования': 'Educational organization',
  'Язык обучения': 'Language of instruction',
  'Новая заявка': 'New application',
  'Другое': 'Other',
  'Без льготы': 'No benefit',
  'Заявка успешно отправлена': 'Application successfully submitted',
  'Ваш ответ': 'Your answer',
  'Язык': 'Language',
  'Заголовок': 'Title',
  'Основной текст': 'Main text',
  'Картинка': 'Image',
  'Вы действительно хотите удалить эту новость?': 'Are you sure you want to delete this news item?',
  'Причина отказа': 'Rejection reason',
  'Уточнение причины отказа на русском языке': 'Rejection reason details in Russian',
  'Уточнение причины отказа на казахском языке': 'Rejection reason details in Kazakh',
  'Перечень отсутствующих документов на русском языке': 'List of missing documents in Russian',
  'Перечень отсутствующих документов на казахском языке': 'List of missing documents in Kazakh',
  'Заявка успешно обработана.': 'Application successfully processed.',
  'Количество мест': 'Number of seats',
  'Изменения успешно сохранены': 'Changes saved successfully',
  'Номер общежития': 'Dormitory number',
  'Адрес общежития на казахском': 'Dormitory address in Kazakh',
  'Адрес общежития на русском': 'Dormitory address in Russian',
  'На какой учебный год': 'For which academic year',
  'Пароль': 'Password',
  'Первый обязательный предмет': 'First required subject',
  'Второй обязательный предмет': 'Second required subject',
  'Настроить': 'Configure',
  'Первый профильный предмет': 'First profile subject',
  'Второй профильный предмет': 'Second profile subject',
  'Создать новую заявку': 'Create new application',
  'Пароль от ЭЦП': 'EDS password',
  'Введите номер расписки': 'Enter receipt number',
  'Введите дату расписки': 'Enter receipt date',
  'Добавить новую заявку': 'Add new application',
  'Поиск по ИИН': 'Search by IIN',
  'Открыть в новом окне': 'Open in new window',
  'Назначение экзамена': 'Exam scheduling',
  'Некорректные заявки': 'Invalid applications',
  'Редактировать количество мест': 'Edit number of seats',
  'Минимальное количество мест: 1': 'Minimum number of seats: 1',
  'Экспортировать в Excel': 'Export to Excel',
  'Выставить оценки': 'Enter grades',
  'Передача персональных данных третьим лицам преследуется законом РК': 'Transfer of personal data to third parties is punishable under the law of the Republic of Kazakhstan',
  'Настройка формулы СКБ': 'ACS formula settings',
  'Оценки СКБ': 'ACS grades',
  'Выставить оценки СКБ': 'Enter ACS grades',
  'Выбраны одинаковые предметы': 'Duplicate subjects selected',
  'Настроите формулу СКБ': 'Configure the ACS formula',
  'Это заявка отправлено на неосвоенное место. Если нажимаете кнопку принять, заявка принимается сразу. Просим быть внимательными!': 'This application was submitted for an undeveloped seat. If you click accept, the application is accepted immediately. Please be careful!',
  'Отменить решение': 'Cancel decision',
  'Ваш QR': 'Your QR',
  'Для входа в мобильное приложение': 'For mobile app sign-in',
  'Медицинская справка 075/У (086)': 'Medical certificate 075/U (086)',
  'Медицинские справки': 'Medical certificates',
  'Номер телефона абитуриента': 'Applicant phone number',
  'Целевой грант': 'Targeted grant',
  'Хочу участвовать в целевом гранте': 'I want to participate in the targeted grant',
  'Из них целевой грант': 'Including targeted grant',
  'Целевой грант не может быть больше чем количество мест': 'Targeted grant cannot exceed the number of seats',
  'Добавить заявку': 'Add application',
  'Добавить заявку по целевому гранту': 'Add targeted grant application',
  'Управление заявками': 'Application management',
  'Отозвать': 'Withdraw',
  'С Единой инструкцией по проведению Конкурса ознакомлен(-а)': 'I have read the Unified Competition Instructions',
  'Даю согласие на сбор, обработку персональных данных': 'I consent to the collection and processing of personal data',
  'Распечатать заявку': 'Print application',
  'Форма электронного заявления': 'Electronic application form',
  'Подано через ИС Абитуриент EDUS': 'Submitted via EDUS Abiturient Information System',
  'Фамилия, имя, отчество поступающего': 'Applicant full name',
  'Контактный телефон (с указанием номера мамы, если абитуриент - ребенок)': 'Contact phone (with mother\'s number if the applicant is a child)',
  'Код и наименование': 'Code and name',
  'специальности и организации ТиППО': 'of specialty and TVET organization',
  'ТиППО': 'TVET organization',
  'Базовое образование': 'Basic education',
  'Предусматривается квота приема': 'Admission quota applies',
  'Добавить еще одну специальность': 'Add another specialty',
  'Выставить оценки экзамена': 'Enter exam grades',
  'В обработке': 'In progress',
  'Принятые': 'Accepted',
  'Отказанные': 'Rejected',
  'Отозванные': 'Withdrawn',
  'Назначить собеседование по целевому гранту': 'Schedule targeted grant interview',
  'ФИО': 'Full name',
  'Квота приема': 'Admission quota',
  'Статус': 'Status',
  'Подано через': 'Submitted via',
  'Источник': 'Source',
  'Есть': 'Yes',
  'Нет': 'No',
  'Заявка': 'Application',
  'Заявка в ручную': 'Manual application',
  'Загрузить данные с mektep.edu.kz': 'Load data from mektep.edu.kz',
  'Данные о детях, достигших выпускного возраста, отсутствуют в базе.': 'No data found for children who have reached graduation age.',
  'Подтверждение по SMS': 'SMS verification',
  'Мы отправили вам сообщение для подтверждения вашей личности. После подтверждения, нажмите на кнопку "Обновить".': 'We sent you a message to verify your identity. After verification, click the "Refresh" button.',
  'Обновить': 'Refresh',
  'Данные не найдены': 'Data not found',
  'Выберите способ подачи заявки': 'Select application submission method',
  'Как абитуриент': 'As applicant',
  'Подать заявку на поступление от своего имени': 'Submit an admission application in your own name',
  'Через ГБДФЛ': 'Via GBDFL',
  'Подать заявку на поступление за ребёнка через подтверждение по SMS': 'Submit an admission application for a child via SMS verification',
  'Назад к выбору способа': 'Back to method selection',
  'Выберите детей': 'Select children',
  'Выбор ребёнка': 'Child selection',
  'Выберите способ авторизации': 'Select authorization method',
  'Вход через ЭЦП': 'Sign in with EDS',
  'Авторизация с помощью электронно-цифровой подписи физического лица': 'Authorization using an individual electronic digital signature',
  'Вход по паролю': 'Sign in with password',
  'Авторизация с помощью логина и пароля личного кабинета': 'Authorization using personal account login and password',
  'Логин': 'Login',
  'Ошибка авторизации': 'Authorization error',
  'Назад к выбору способа авторизации': 'Back to authorization method selection',
  'Информация о заявке': 'Application information',
  'Номер заявки': 'Application number',
  'Статус заявки': 'Application status',
  'Основные персональные данные Абитуриента': 'Applicant main personal data',
  'День рождения': 'Date of birth',
  'Данные об образовании': 'Education data',
  'Тип документа о полученном образовании': 'Type of education document',
  'Страна окончания школы': 'School graduation country',
  'Регион окончания школы': 'School graduation region',
  'Наименование школы': 'School name',
  'Год окончания (выпуска)': 'Graduation year',
  'Тип квоты приема': 'Admission quota type',
  'Документ о квоте': 'Quota document',
  'Квалификация №': 'Qualification No.',
  'Наименование квалификации': 'Qualification name',
  'Код квалификации': 'Qualification code',
  'Наименование колледжа': 'College name',
  'БИН колледжа': 'College BIN',
  'Участвует в целевом гранте': 'Participates in targeted grant',
  'Экзамен': 'Exam',
  'Да': 'Yes',
  'Подтвердить': 'Confirm',
  'Вы действительно хотите отозвать заявку?': 'Are you sure you want to withdraw the application?',
  'Редактирование заявки': 'Edit application',
  'Нет изменений для сохранения': 'No changes to save',
  'Заявка успешно обновлена': 'Application updated successfully',
  'Редактирование заявки недоступно': 'Application editing is unavailable',
  'Размер файла не должен превышать 10 Мб': 'File size must not exceed 10 MB',
  'Квалификации': 'Qualifications',
  'Не удалось загрузить файл': 'Failed to upload file',
  'Сменить пароль': 'Change password',
  'Смена пароля': 'Password change',
  'Новый пароль': 'New password',
  'Пароль успешно изменен': 'Password changed successfully',
  'Создание логина и пароля': 'Create login and password',
  'У вас пока нет логина и пароля. Создайте их для входа по паролю в личный кабинет.': 'You do not have a login and password yet. Create them to sign in to your personal account with a password.',
  'Логин и пароль успешно созданы': 'Login and password created successfully',
  'Неразвитые места': 'Undeveloped seats',
  'Разница': 'Difference',
  'Общее количество мест': 'Total number of seats',
  'Оставшиеся места': 'Remaining seats',
  'Код специальности': 'Specialty code',
  'Медицинские данные': 'Medical data',
  'Поступающий/Учащийся': 'Applicant/Student',
  'Вы уверены, что хотите отозвать заявку?': 'Are you sure you want to withdraw the application?',
  'Родитель/законный представитель': 'Parent/legal representative',
  'Ошибка': 'Error',
  'Неосвоенные места': 'Unfilled seats',
  'Приемная комиссия': 'Admissions office',
  'Выберите специальность': 'Select specialty',
  'ИИН абитуриента': 'Applicant IIN',
  'Средняя оценка аттестата': 'Average certificate grade',
  'Средний конкурсный балл': 'Average competition score',
  'Абитуриент не найден': 'Applicant not found',
  'Размер картинки не должен превышать 2 Мб': 'Image size must not exceed 2 MB',
  'Заявка вручную': 'Manual application',
  'Введите только числа': 'Enter numbers only',
  'Выставить оценки по целевому гранту': 'Enter targeted grant grades',
  'Дата': 'Date',
  'Время': 'Time',
  'Адрес': 'Address',
  'Оценка': 'Grade',
  'Cобеседование по целевому гранту': 'Targeted grant interview',
  'Успешно': 'Success',
  'Скачать': 'Download',
  'Принять': 'Accept',
  'Отклонить': 'Reject',
  'Вы действительно хотите принять заявку': 'Are you sure you want to accept the application',
  'Вы действительно хотите отклонить заявку': 'Are you sure you want to reject the application',
  'Вы действительно хотите отменить решение': 'Are you sure you want to cancel the decision',
  'Причина отмены': 'Cancellation reason',
  'Общие данные': 'General data',
  'Данные по колледжам': 'College data',
  'Мониторинг заявок': 'Application monitoring',
  'Языковая группа': 'Language group',
  'Остальные предметы': 'Other subjects',
  '+ Добавить предмет': '+ Add subject',
  'Предмет': 'Subject',
  'Учебное заведение': 'Educational institution',
  'Тип квоты': 'Quota type',
  'Назначение экзаменов': 'Exam scheduling',
  'Дата проведения': 'Exam date',
  'Время (HH:mm)': 'Time (HH:mm)',
  'Укажите время в формате ЧЧ:мм': 'Enter time in HH:mm format',
  'Место проведения': 'Exam location',
  'Назначить': 'Assign',
  'Оценка экзаменов': 'Exam grading',
  'Оценки аттестата': 'Certificate grades',
  'Редактирование оценок аттестата': 'Edit certificate grades',
  'Оценки аттестата обновлены': 'Certificate grades updated',
  'Выберите ЭЦП и введите пароль': 'Select EDS and enter password',
  'Выбрать': 'Select',
  'Дата и время': 'Date and time',
  'СБА': 'ASC',
  'СКБ': 'ACS',
  'Общая статистика': 'General statistics',
  'Статистика по квотам': 'Quota statistics',
  'Выделенные места и Поступившие заявки': 'Allocated seats and received applications',
  'Количество выделенных мест': 'Number of allocated seats',
  'Выбери ребенка': 'Select a child',
  'Неделя': 'Week',
  'Месяц': 'Month',
  'Все': 'All',
  'Квалификация': 'Qualification',
  'Тип оплаты': 'Payment type',
  'Обучение по государственному заказу': 'State-funded education',
  'Государственный заказ': 'State order',
  'Категория заявителя': 'Applicant category',
  'Номер телефона родителей': "Parents' phone number",
  'Личные данные': 'Personal data',
  'Гражданство': 'Citizenship',
  'Документы': 'Documents',
  'Родитель': 'Parent',
  'Рассмотрение заявки': 'Application review',
  'Оценивание': 'Grading',
  'Отказать': 'Reject',
  'Отказ в заявке': 'Reject application',
  'Заявка отклонена.': 'Application rejected.',
  'Документ не найден': 'Document not found',
  'Отказать в приёме заявки?': 'Reject this application?',
  'Поставить оценку экзамена': 'Set exam grade',
  'Поставить оценку СКБ': 'Set ACS grade',
  'Казахстан': 'Kazakhstan',
  'Репатриант': 'Repatriate',
  'Оралман': 'Oralman',
  'Резидент РК': 'RK resident',
  'Гражданин РК': 'RK citizen',
  'Наименование': 'Name',
  'Форма собственности': 'Form of ownership',
  'Телефон': 'Phone',
  'Пункт образования': 'Education point',
  'Тип организации': 'Organization type',
  'БИН': 'BIN',
  'Частная': 'Private',
  'Государственная': 'State-owned',
  'Республиканский': 'Republican',
  'Государственное учреждение': 'State institution',
  'Частное учреждение': 'Private institution',
  'Оценки СКБ': 'ACS scores',
  'Ожидающие итогов конкурса': 'Awaiting competition results',
  'Не прошедшие конкурс': 'Did not pass the competition',
  'Прошедшие конкурс': 'Passed the competition',
  'СКБ формула не настроена!': 'The ACS formula is not configured!'
};
